import { StandardDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { SendWireStepper } from 'libs/feature-send-wire/src/components/sendWireStepper';
import { useEffect, useState } from 'react';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';
import { runInAction } from 'mobx';
import { isNil } from '@roc/feature-utils';

export const SendWire = observer(({ loanId, drawId, afterActionExecuted }) => {
  const { drawStore: { drawActionsStore } } = useDrawsStore();

  return (
    <StandardDialog
      title="Send Wire"
      open={drawActionsStore.isSendWireDialogOpen}
      dialogContent={
        <SendWireContent loanId={loanId} drawId={drawId} afterActionExecuted={afterActionExecuted} />
      }
      onClose={() => drawActionsStore.setIsSendWireDialogOpen(false)}
      handleClose={() => drawActionsStore.setIsSendWireDialogOpen(false)}
      maxWidth={'lg'}
      removeContentBox
    />
  );
});

export const SendWireContent = observer(({ loanId, drawId, afterActionExecuted }) => {
  const { sendWireInternalStore, drawStore } = useRocInternalPortalStore();

  const [localDrawId, setLocalDrawId] = useState(drawId);
  const [localLoanId, setLocalLoanId] = useState(loanId);

  useEffect(() => {
    sendWireInternalStore?.setDefaults();
  }, [])

  useEffect(() => {
    if (localDrawId !== sendWireInternalStore?.drawId || localLoanId !== sendWireInternalStore?.loanId) {
      runInAction(() => {
        sendWireInternalStore.drawId = localDrawId;
        sendWireInternalStore.loanId = localLoanId;
      })
    }
  }, [localDrawId, localLoanId])

  useEffect(() => {
    if (localLoanId) {
      sendWireInternalStore?.init()
    }
  }, [localLoanId])

  useEffect(() => {
    if (localDrawId && !isNil(drawStore?.drawDTO?.draw?.wireId)) {
      sendWireInternalStore.getWireDetails(drawStore?.drawDTO?.draw?.wireId);
    }
  }, [localDrawId])

  return <SendWireStepper afterActionExecuted={afterActionExecuted} />;
});
